// extracted by mini-css-extract-plugin
module.exports = {"shadow":"chart_shadow__2pxLY","textShadow":"chart_textShadow__CD3m4"};